export default {
  functionKey: "CONCATENER",
  title: "CONCATENER",
  group: "Texte",
  target: [],
  targetRequired: true,
  arguments: [],
  description: "Ajoutez les arguments qui seront concaténés",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    let jsCode = `${destination} = `;
    for (let i = 0; i < args.length; i++) {
      jsCode += `${args[i]} + `;
    }
    jsCode = jsCode.substring(0, jsCode.length - 3);
    return { displayCode: `${jsCode};`, safeCode: `${jsCode};` };
  }
}
